import React from 'react';
import s from '../About/About_us.module.css';
import Cell from '../About/AboutImg/Cell.png';
import Group from '../About/AboutImg/Group.png';
import Container from '../Container/Container';

export default function offer() {
  return (
    <div className={s.OffercConteinerAccesories}>
      <Container>
        <div className={s.Offer_right_block}>
          <img src={Cell} alt="img" />
          <h2 className={s.titleOffer}>Що ми пропонуємо? </h2>
          <ul className={s.OfferAccessories}>
            <li className={s.offerInfo}>
              Ігрові клавіатури, а також клавіатури для дому та офісу
            </li>
            <li className={s.offerInfo}>
              Спритні геймерські мишки та універсальні миші для повсякденного
              використання
            </li>
            <li className={s.offerInfo}>Ігрові поверхні (килимки) для мишок</li>
            <li className={s.offerInfo}>Зручні ігрові та офісні крісла</li>
            <li className={s.offerInfo}>
              Тригери і геймпади для початківців та просунутих гравців
            </li>
            <li className={s.offerInfo}>Охолоджуючі підставки для ноутбука</li>
            <li className={s.offerInfo}>
              Багатофункціональну гарнітуру і веб-камери
            </li>
          </ul>
        </div>

        <div className={s.Offer_left_block}>
          <img src={Group} alt="" className={s.OfferImg_right_block} />
        </div>
      </Container>
    </div>
  );
}
